import React from 'react';
import { Card, Flex, Image, Layout, Row, Col, Grid } from 'antd';
import fondo from "./../assets/images/fondo.png";
import conalepEDOMEX from "./../assets/images/escudos/conalepEDOMEX.png";
 
 
const imgStyle = {
    width: 600,
};
const { Content } = Layout;
const { useBreakpoint } = Grid;



export default function EstructureLogin({ componente: Componente }) {
    const screens = useBreakpoint();

    const cardWidth = () => {
        if (screens.xs) return '100%'; // Extra pequeño
        if (screens.sm) return '80%'; // Pequeño
        if (screens.md) return '70%'; // Mediano
        if (screens.lg) return '60%'; // Grande
        return '50%'; // Por defecto, para extra grande y más grande
    };

    return (
        <Layout style={{ backgroundColor: '#EAEDED', height: '100vh', width: '100vw', minWidth: '300px' }}>
            <Row justify="center" align="middle" style={{ height: '90vh', }}>
                <Card
                    style={{ width: cardWidth(), maxWidth: '1200px', margin: '0 auto' }}
                    styles={{
                        body: {
                            padding: 0,
                            overflow: 'hidden',
                        },
                    }}
                >
                    <Flex justify="center">
                        <Col
                            xs={{ span: 20 }} sm={24} md={24} lg={18} xl={{ span: 12, offset: 2 }} xxl={{ span: 12, offset: 1 }}
                        >
                            <Content>
                                <Row className="red-linePrueba" />
                                <Row className="brown-linePrueba" />
                                <Row justify="end">
                                    <Image style={{ marginTop: "20px" }} className='paddingPersonalizado' width={200} preview={false} src={conalepEDOMEX} alt="logotipo Conapel EDOMEX" />
                                </Row>
                                <Row>
                                    {Componente}
                                </Row>
                            </Content>
                        </Col>
                        <Col
                            xs={{ span: 0, offset: 2 }} sm={0} md={0} lg={2} xl={{ span: 12, offset: 2 }} xxl={{ span: 12, offset: 0 }} 
                        >
                            <Image
                                preview={false}
                                src={fondo}
                                style={imgStyle}
                            />
                        </Col>
                    </Flex>
                </Card>
            </Row>
        </Layout>
    );
} 